import {Headline2} from '@brutex/web-component-library/ts';
import React from 'react';

import Footer from '@/components/common/Footer';
import Navbar from '@/components/common/Navbar';
import PageMeta from '@/components/PageMeta';
import YoutubePlayerCard from '@/components/player-card/YoutubePlayerCard';
import {t} from '@/plugins/i18n';

const Page: React.FC = () => {
    const videos = [
        {
            title: 'Expert tips for 3D furniture visualisation',
            videoId: 'geFin3nxfw0',
            thumbnail: 'vlog/videos/FurnitureMarketingWith3DVisualisation.jpg',
        },
        {
            title: 'Furniture marketing with 3D visualisation',
            videoId: 'mRrbb_JGkug',
            thumbnail: 'vlog/videos/SustainablePowerOfDigitalPrototyping.jpg',
        },
        {
            title: 'The sustainable power of digital prototyping',
            videoId: 'jf_4TMXJbDw',
            thumbnail: 'vlog/videos/ExpertTipsFor3DFurnitureVisualisation.jpg',
        },
        {
            title: 'Benefits of 3D fabric textures for interior design',
            videoId: 'nbZCAoJfhNY',
            thumbnail: 'vlog/videos/BenefitsOf3DFabricTexturesForInteriorDesign.jpg',
        },
        {
            title: 'How 3D renders can boost your business',
            videoId: 're-WPhn8_L8',
            thumbnail: 'vlog/videos/How3dRendersCanGrowBusiness.jpg',
        },
        {
            title: '3D renders bringing interior design to life',
            videoId: 'HhHKfo9NxEg',
            thumbnail: 'vlog/videos/3DRendersBringInteriorDesignToLife.png',
        },
        {
            title: 'Collaborative 3D design with NVIDIA Omniverse',
            videoId: 'PxfMFHHp-Yo',
            thumbnail: 'vlog/videos/CollaborativeDesignWithNvidia.png',
        },
        {
            title: 'Five benefits of digital fabric catalogues',
            videoId: 'fkEEyUwWVeU',
            thumbnail: 'vlog/videos/BenefitsOfDigitalFabricCatalogues.png',
        },
        {
            title: 'How fabric digital twins can boost sustainability in the textile industry',
            videoId: 'qnX3a3JSXQM',
            thumbnail: 'vlog/videos/HowDigitalTwinsCanBoostSustainability.jpg',
        },
        {
            title: 'A digital partnership for better customer experiences',
            videoId: 'YPDNf-Lx7Vk',
            thumbnail: 'vlog/videos/BetterCustomerExperience.jpg',
        },
        {
            title: 'Creating a utopia with digital fabrics for the metaverse',
            videoId: '1ou8EJapTfE',
            thumbnail: 'vlog/videos/CreatingForTheMetaverse.jpg',
        },
        {
            title: 'Twinbru explores digital solutions to future-proof your business',
            videoId: 'RgCb0L-uMUU',
            thumbnail: 'vlog/videos/DigitalSolutionsToFutureproofBusiness.jpg',
        },
        {
            title: 'The best digitisation technique for fabrics',
            videoId: 'dtr6ac66N5o',
            thumbnail: 'vlog/videos/DigitalTwinsFromPhysicalF.jpg',
        },
        {
            title: 'Creating realistic looking velvet fabric renders',
            videoId: 'OVW6fy-POYI',
            thumbnail: 'vlog/videos/RealisticLookingVelvetFabricRenders.jpg',
        },
        {
            title: 'Hot colour trends in 2022',
            videoId: '6nKAYZ6nwdI',
            thumbnail: 'vlog/videos/ColourTrend2022.jpg',
        },
        {
            title: 'Creating digital twins from physical fabrics',
            videoId: 'Nn_s1eBC9Kw',
            thumbnail: 'vlog/videos/DigitalTwinsFromPhysicalFabrics.jpg',
        },
        {
            title: 'Digital twins will change the future of interior design',
            videoId: 'uC3tPyQRh08',
            thumbnail: 'vlog/videos/DigitalTwinsWillChangeFuture.jpg',
        },
        {
            title: 'How interior designers will work in the near future',
            videoId: 'B2432V5aXW4',
            thumbnail: 'vlog/videos/HowInteriorDesignersWillWork.jpg',
        },
    ];
    return <>
        <PageMeta
            description='With our services and research & development, we help you future-proofing your business'
            title='Vlogs'
        ></PageMeta>

        <Navbar />

        <div>
            <Headline2
                body={t('page.vlogs.head1.body')}
                cls='pt-34 pt-md-40 pt-xl-48'
                subtitle={t('page.vlogs.head1.subTitle')}
                title={t('page.vlogs.head1.title')}
            />


            <div className='container-fluid py-16'>
                <div className='row justify-content-center'>
                    {videos.map((video, index) => (
                        <div className='col mt-8 col-12 col-md-6 col-lg-4'
                            key={`vlog-video-${index}`}>
                            <YoutubePlayerCard elementId={`vlog-video-${index}`}
                                thumbnail={video.thumbnail}
                                title={video.title}
                                videoId={video.videoId} />
                        </div>
                    ))}
                </div>

            </div>
        </div>


        <Footer />
    </>;
};

export default Page;
